<template>
    <section class="fibu-kontenblatt-filter">
        <h3>Filter</h3>
        <b-form @submit="onSubmit" @reset="onReset">
            <b-row>
                <b-col>
                    <b-form-group
                        label="Zeitraum von:"
                        label-for="inputFromDate"
                        :label-size="size"
                    >
                        <b-input
                            type="date"
                            id="inputFromDate"
                            v-model="filter._from_date"
                            :size="size"
                        />
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group
                        label="Zeitraum bis:"
                        label-for="inputToDate"
                        :label-size="size"
                    >
                    <b-input
                        type="date"
                        id="inputToDate"
                        v-model="filter._to_date"
                        :size="size"
                    />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-form-group
                label-cols-sm="2"
                label="Sortierung:"
                label-for="inputOrderBy"
                :label-size="size"
            >
                <b-select
                    id="inputOrderBy"
                    v-model="filter.orderby"
                    :options="orderby"
                    :size="size"
                />
            </b-form-group>

            <hr>

            <b-form-group
                label-cols-sm="2"
                label="Kontenart:"
                label-for="inputKntType"
                :label-size="size"
            >
                <b-select
                    id="inputKntType"
                    v-model="filter.type"
                    :options="type"
                    :size="size"
                />
            </b-form-group>
            <template v-if="filter.type === 'buchungskonto'">
                <hr>

                <b-row
                  v-if="buchungskonto.items.length"
                >
                    <b-col>
                        <b-form-group
                            label="Kontoauswahl von:"
                            label-for="inputFromBuchungsKnt"
                            :label-size="size"
                            :state="validatonState._from_buchungskonto ? validatonState._from_buchungskonto.state : null"
                            :invalid-feedback="validatonState._from_buchungskonto ? validatonState._from_buchungskonto.message : null"
                        >
                            <b-select
                                id="inputFromBuchungsKnt"
                                v-model="filter._from_buchungskonto"
                                :options="buchungskonto.options"
                                :size="size"
                                :state="validatonState._from_buchungskonto ? validatonState._from_buchungskonto.state : null"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            label="Kontoauswahl bis:"
                            label-for="inputToBuchungsKnt"
                            :label-size="size"
                            :state="validatonState._to_buchungskonto ? validatonState._to_buchungskonto.state : null"
                            :invalid-feedback="validatonState._to_buchungskonto ? validatonState._to_buchungskonto.message : null"
                        >
                            <b-select
                                id="inputToBuchungsKnt"
                                v-model="filter._to_buchungskonto"
                                :options="buchungskonto.options"
                                :size="size"
                                :state="validatonState._to_buchungskonto ? validatonState._to_buchungskonto.state : null"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
              <b-row
                v-else
              >
                <ContentLoadingBlock />
              </b-row>
            </template>

            <template v-if="filter.type === 'finanzkonto'">
                <hr>

                <b-row
                    v-if="finanzkonto.items.length"
                >
                    <b-col>
                        <b-form-group
                            label="Kontoauswahl von:"
                            label-for="inputFromFinanzKnt"
                            :label-size="size"
                            :state="validatonState._from_finanzkonto ? validatonState._from_finanzkonto.state : null"
                            :invalid-feedback="validatonState._from_finanzkonto ? validatonState._from_finanzkonto.message : null"
                        >
                            <b-select
                                id="inputFromFinanzKnt"
                                v-model="filter._from_finanzkonto"
                                :options="finanzkonto.options"
                                :size="size"
                                :state="validatonState._from_finanzkonto ? validatonState._from_finanzkonto.state : null"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                            label="Kontoauswahl bis:"
                            label-for="inputToFinanzKnt"
                            :label-size="size"
                            :state="validatonState._to_finanzkonto ? validatonState._to_finanzkonto.state : null"
                            :invalid-feedback="validatonState._to_finanzkonto ? validatonState._to_finanzkonto.message : null"
                        >
                            <b-select
                                id="inputToFinanzKnt"
                                v-model="filter._to_finanzkonto"
                                :options="finanzkonto.options"
                                :size="size"
                                :state="validatonState._to_finanzkonto ? validatonState._to_finanzkonto.state : null"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row
                  v-else
                >
                  <ContentLoadingBlock />
                </b-row>
            </template>

            <template v-if="filter.type === 'zuschusskonto'">
                <hr>

                <b-row
                    v-if="zuschusskonto.items.length"
                >
                    <b-col>
                        <b-form-group
                            label="Zuschusskonto:"
                            label-for="inputZuschussKnt"
                            :label-size="size"
                            :state="validatonState._zuschusskonto ? validatonState._zuschusskonto.state : null"
                            :invalid-feedback="validatonState._zuschusskonto ? validatonState._zuschusskonto.message : null"
                        >
                            <b-select
                                id="inputZuschussKnt"
                                v-model="filter._zuschusskonto"
                                :options="zuschusskonto.options"
                                :size="size"
                                :state="validatonState._zuschusskonto ? validatonState._zuschusskonto.state : null"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row
                    v-else
                >
                    <ContentLoadingBlock />
                </b-row>
            </template>

            <template v-if="filter.type === 'ruecklagenkonto'">
                <hr>

                <b-row
                    v-if="ruecklagenkonto.items.length"
                >
                    <b-col>
                        <b-form-group
                            label="RÜcklagenkonto:"
                            label-for="inputRuecklagenKnt"
                            :label-size="size"
                            :state="validatonState._ruecklagenkonto ? validatonState._ruecklagenkonto.state : null"
                            :invalid-feedback="validatonState._ruecklagenkonto ? validatonState._ruecklagenkonto.message : null"
                        >
                            <b-select
                                id="inputRuecklagenKnt"
                                v-model="filter._ruecklagenkonto"
                                :options="ruecklagenkonto.options"
                                :size="size"
                                :state="validatonState._ruecklagenkonto ? validatonState._ruecklagenkonto.state : null"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row
                    v-else
                >
                    <ContentLoadingBlock />
                </b-row>
            </template>

            <template v-if="filter.type !== 'select'">
                <hr>

                <b-form-group
                        label-cols-sm="2"
                        label="Auswahl Jahresabschlussrelevanter Kategorien (Kategorie 1):"
                        label-for="inputJaCategories"
                        :label-size="size"
                >
                    <CheckboxSelect
                            id="inputJaCategories"
                            v-model="filter.jaCategories"
                            :options="jaCategories"
                            :size="size"
                    />
                    <b-form-checkbox
                        id="jaCategorySums"
                        v-model="filter.showJaSums"
                        name="jaCategorySums"
                        value="true"
                        unchecked-value="false"
                        class="mt-2"
                        :size="size"
                    >
                        Einzelsummen anzeigen
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group
                        label-cols-sm="2"
                        label="Auswahl weiterer Kategorien (Sonstige):"
                        label-for="inputFurtherCategories"
                        :label-size="size"
                >
                    <b-select
                            id="inputFurtherCategories"
                            v-model="filter.furtherCategories"
                            :options="furtherCategories"
                            :size="size"
                    />
<!--                    <CheckboxSelect-->
<!--                            id="inputFurtherCategories"-->
<!--                            v-model="filter.furtherCategories"-->
<!--                            :options="furtherCategories"-->
<!--                            :size="size"-->
<!--                    />-->
                    <b-form-checkbox
                            id="furtherCategorySums"
                            v-model="filter.showFurtherSums"
                            name="furtherCategorySums"
                            value="true"
                            unchecked-value="false"
                            class="mt-2"
                            :size="size"
                    >
                        Einzelsummen anzeigen
                    </b-form-checkbox>
                </b-form-group>

                <hr>

                <b-form-group
                        label-cols-sm="2"
                        label="Verwendungszweck enthält:"
                        label-for="inputVerwendungszweck"
                        :label-size="size"
                >
                    <b-input
                        type="text"
                        id="inputVerwendungszweck"
                        v-model="filter.verwendungszweck"
                        :size="size"
                    />
                </b-form-group>
            </template>

            <div class="d-flex justify-content-between">
                <b-form-group>
                    <b-button
                        type="submit"
                        variant="primary"
                        :size="size"
                        :disabled="filter.type === 'select'"
                    >
                        Anzeigen
                    </b-button>
                    <b-button
                        type="reset"
                        variant="outline-danger"
                        :size="size"
                        class="ml-1"
                        @click="reset"
                    >
                        Felder zurücksetzen
                    </b-button>
                </b-form-group>
                <b-form-group
                    v-if="Object.keys(data).length"
                >
                    <b-dropdown
                        split
                        variant="primary"
                        :size="size"
                        split-button-type="button"
                        @click="printKontenblaetter"
                        text="Druckvorschau anzeigen"
                    >
                        <b-dropdown-item
                            split-button-type="button"
                            @click="printKontenblaetter(1)"
                        >
                            nur Kat. 1 drucken
                        </b-dropdown-item>
                        <b-dropdown-item
                            split-button-type="button"
                            @click="printKontenblaetter(2)"
                        >
                            nur Kat. 2 drucken
                        </b-dropdown-item>
                    </b-dropdown>
                </b-form-group>
            </div>

        </b-form>
    </section>
</template>
<script>
    import Size from "@/mixins/Size/Size";
    import { ApiFactory } from "@/api/ApiFactory";
    import CheckboxSelect from "@/components/CheckboxSelect/CheckboxSelect.vue";
    import {BlobUtil} from "@/utils/BlobUtil";
    import Toaster from "@/mixins/Toaster/Toaster";
    import ContentLoadingBlock from "@/components/ContentLoadingBlock/ContentLoadingBlock.vue";

    const FiBuKontenblaetterApi = ApiFactory.get('fibuKontenblaetterApi');

    export default {
        name: "KontenblaetterFilter",
        props: ['finanzkonto', 'buchungskonto', 'zuschusskonto', 'ruecklagenkonto', 'jaCategories', 'furtherCategories', 'data', 'validation'],
        mixins: [Size, Toaster],
        components: {
          ContentLoadingBlock,
            CheckboxSelect,
        },
        data() {
            return {
                api: FiBuKontenblaetterApi,
                prefetch: false,
                filter: {
                    orderby: 'datum',
                    type: 'select',
                    _from_date: null,
                    _to_date: null,
                    _from_buchungskonto: null,
                    _to_buchungskonto: null,
                    _from_finanzkonto: null,
                    _to_finanzkonto: null,
                    _zuschusskonto: null,
                    _ruecklagenkonto: null,
                    jaCategories: [],
                    furtherCategories: null,
                    showJaSums: false,
                    showFurtherSums: false,
                    verwendungszweck: null
                },
                type: [
                    {
                        value: 'select',
                        text: 'Bitte Kontenart wählen'
                    },
                    {
                        value: 'finanzkonto',
                        text: 'Finanzkonto'
                    },
                    {
                        value: 'buchungskonto',
                        text: 'Buchungskonto'
                    },
                    {
                        value: 'zuschusskonto',
                        text: 'Zuschusskonto'
                    },
                    {
                        value: 'ruecklagenkonto',
                        text: 'Rücklagenkonto'
                    }
                ],
                orderby: [
                    {
                        value: 'id',
                        text: 'ID'
                    },
                    {
                        value: 'buchungsnr',
                        text: 'Buchungsnr.'
                    },
                    {
                        value: 'datum',
                        text: 'Buchungsdatum'
                    },
                ]
            }
        },
        computed: {
            validatonState() {
                let result = {};
                for(const [key,value] of Object.entries(this.validation)) {
                    result[key] = {
                        state: false,
                        message: value.join(', ')
                    }
                }
                return result;
            }
        },
        created() {
            const pages = this.$store.getters.getPages;

            if(pages.fibu_kontenblaetter.editBuchung) {
                this.filter = pages.fibu_kontenblaetter.filter;

                pages.fibu_kontenblaetter.editBuchung = false;

                this.submit();
            } else {
                this.setDefaultFilter();
            }
        },
        methods: {
            async printKontenblaetter(exclusiveCategoryGroup) {
                this.busy = true;

                this.$emit('printKontenblaetter', true);

                const currentFilter = {
                    showJaSums: this.filter.showJaSums,
                    showFurtherSums: this.filter.showFurtherSums,
                }

                if (exclusiveCategoryGroup === 1) {
                    this.filter.showJaSums = true;
                    this.filter.showFurtherSums = false;
                }
                if (exclusiveCategoryGroup === 2) {
                    this.filter.showJaSums = false;
                    this.filter.showFurtherSums = true;
                }

                const response = await FiBuKontenblaetterApi.print({
                    filter: this.filter
                });

                if(response.ok) {
                    const hasPopUpBlocker = BlobUtil.openBlob(response.blob);

                    this.filter.showJaSums = currentFilter.showJaSums;
                    this.filter.showFurtherSums = currentFilter.showFurtherSums;

                    if(hasPopUpBlocker) {
                        this.$emit('popupinfo');
                    }
                }

                this.$emit('kontenblaetterPrinted', false);

                this.busy = false;
            },
            setDefaultFilter() {
                if(!this.filter._from_date) {
                    this.filter._from_date = this.$moment().startOf('year').format('YYYY-MM-DD');
                }
            },
            processFilter() {
                var filter = Object.assign({}, this.filter);
                var processedFilter = {};
                for (const prop in filter) {
                    if (filter[prop] !== null) {
                        processedFilter[prop] = filter[prop];
                    }
                }
                return processedFilter;
            },
            submit() {
                const filter = this.processFilter();

                console.log('test')

                this.$emit('submit', { ...filter });

                this.$store.dispatch("pages", {
                    fibu_kontenblaetter: {
                        filter: filter
                    }
                });
            },
            reset() {
                this.filter = {
                    orderby: 'datum',
                    type: 'select',
                    _from_date: null,
                    _to_date: null,
                    _from_buchungskonto: null,
                    _to_buchungskonto: null,
                    _from_finanzkonto: null,
                    _to_finanzkonto: null,
                    _zuschusskonto: null,
                    _ruecklagenkonto: null,
                    jaCategories: [],
                    furtherCategories: null,
                    showJaSums: false,
                    showFurtherSums: false,
                    verwendungszweck: null,
                };

                this.$emit('resetData');

                this.$store.dispatch("pages", {
                    fibu_kontenblaetter: {
                        filter: this.filter
                    }
                });
            },
            onSubmit(evt) {
                evt.preventDefault();
                this.submit();
            },
            onReset(evt) {
                evt.preventDefault();
                this.reset();
            },

        },
        watch: {
            'filter.type': {
                handler(val) {
                    if(val === 'buchungskonto' && !this.buchungskonto.items.length) {
                        this.$emit('fetchBuchungsKnt');
                    }

                    if(val === 'finanzkonto' && !this.finanzkonto.items.length) {
                        this.$emit('fetchFinanzKnt');
                    }

                    if(val === 'zuschusskonto' && !this.zuschusskonto.items.length) {
                        this.$emit('fetchZuschussKnt');
                    }

                    if(val === 'ruecklagenkonto' && !this.ruecklagenkonto.items.length) {
                        this.$emit('fetchRuecklagenKnt');
                    }

                    this.filter._to_finanzkonto = null;
                    this.filter._from_finanzkonto = null;
                    this.filter._to_buchungskonto = null;
                    this.filter._from_buchungskonto = null;
                    this.filter._zuschusskonto = null;
                }
            },
        }
    }

</script>